export default "__VITE_ASSET__DeziTmfA__"